import React from "react";

/**
 * Renders basic **bold** markdown in advisor chat bubbles as plain React text.
 */
export const formatAdvisorMessageContent = (text) => {
  if (text == null || text === "") return null;

  const lines = String(text).split("\n");

  return lines.map((line, lineIndex) => {
    const parts = [];
    const regex = /\*\*(.+?)\*\*/g;
    let lastIndex = 0;
    let match;
    let partKey = 0;

    while ((match = regex.exec(line)) !== null) {
      if (match.index > lastIndex) {
        parts.push(line.slice(lastIndex, match.index));
      }
      parts.push(
        <strong key={`${lineIndex}-${partKey}`}>{match[1]}</strong>
      );
      partKey += 1;
      lastIndex = regex.lastIndex;
    }

    if (lastIndex < line.length) {
      parts.push(line.slice(lastIndex));
    }

    return (
      <React.Fragment key={lineIndex}>
        {lineIndex > 0 && <br />}
        {parts.length > 0 ? parts : line}
      </React.Fragment>
    );
  });
};
